import _axios from 'axios'

export default _axios.create({
  baseURL: window.appConfig.serverUrl,
  responseType: 'json'
})
